import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  SupportTicketListItem,
  ContactTicketHistoryItem,
  SupportTicketDetail,
  SupportTicketFilter,
  CreateTicketRequest,
  UpdateTicketRequest,
  AssignTicketRequest,
  ChangeStatusRequest,
  CloseTicketRequest,
  CreateTicketFromConversationRequest
} from '../models/support-ticket.model';

@Injectable({ providedIn: 'root' })
export class SupportTicketApiService {
  private base = `${environment.apiUrl}api/tickets`;
  private agentBase = `${environment.apiUrl}api/agent/conversations`;

  constructor(private http: HttpClient) {}

  getTickets(filters?: SupportTicketFilter): Observable<SupportTicketListItem[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.status)        params = params.set('status', filters.status);
      if (filters.priority)      params = params.set('priority', filters.priority);
      if (filters.teamId)        params = params.set('team_id', filters.teamId.toString());
      if (filters.search)        params = params.set('search', filters.search);
      if (filters.assignedToMe)  params = params.set('assigned_to_me', 'true');
      if (filters.contactId)     params = params.set('contact_id', filters.contactId.toString());
    }
    return this.http.get<SupportTicketListItem[]>(this.base, { params });
  }

  /**
   * Historial de tickets de un contacto — `GET /api/tickets/contact/{id}/history`.
   *
   * El panel CRM de la bandeja lo pedía antes a `GET /api/tickets` con `contact_id`/`status`,
   * parámetros que ese endpoint NO acepta; además devuelve un `PageResponse`, no un array, así
   * que el listado salía siempre vacío. Este endpoint sí existe, devuelve un array y trae los
   * nombres ya resueltos (`statusName`, `priorityName`) en vez de ids.
   */
  getContactTicketHistory(contactId: number): Observable<ContactTicketHistoryItem[]> {
    return this.http.get<ContactTicketHistoryItem[]>(`${this.base}/contact/${contactId}/history`);
  }

  getTicketById(id: number): Observable<SupportTicketDetail> {
    return this.http.get<SupportTicketDetail>(`${this.base}/${id}`);
  }

  createTicket(payload: CreateTicketRequest): Observable<SupportTicketDetail> {
    return this.http.post<SupportTicketDetail>(this.base, payload);
  }

  updateTicket(id: number, payload: UpdateTicketRequest): Observable<SupportTicketDetail> {
    return this.http.put<SupportTicketDetail>(`${this.base}/${id}`, payload);
  }

  assignTicket(id: number, payload: AssignTicketRequest): Observable<SupportTicketDetail> {
    return this.http.post<SupportTicketDetail>(`${this.base}/${id}/assign`, payload);
  }

  changeTicketStatus(id: number, payload: ChangeStatusRequest): Observable<SupportTicketDetail> {
    return this.http.post<SupportTicketDetail>(`${this.base}/${id}/status`, payload);
  }

  closeTicket(id: number, payload: CloseTicketRequest): Observable<SupportTicketDetail> {
    return this.http.post<SupportTicketDetail>(`${this.base}/${id}/close`, payload);
  }

  createTicketFromConversation(conversationId: number, payload: CreateTicketFromConversationRequest): Observable<SupportTicketDetail> {
    return this.http.post<SupportTicketDetail>(`${this.agentBase}/${conversationId}/create-ticket`, payload);
  }
}
